import React, { useEffect, useState } from "react";

const VideoSchema = () => {
    const [videoSchema, setVideoSchema] = useState([]);

    useEffect(() => {
        // Fetch the videos.json file from public folder
        fetch("/json/videos.json")
            .then((res) => {
                if (!res.ok) throw new Error("Failed to load video data");
                return res.json();
            })
            .then((videos) => {
                // Map videos to VideoObject schema format
                const schemaVideos = videos.map((video) => ({
                    "@context": "https://schema.org",
                    "@type": "VideoObject",
                    "name": video.name,
                    "description": video.description,
                    "thumbnailUrl": video.thumbnailUrl,
                    "uploadDate": video.uploadDate,
                    "embedUrl": video.embedUrl,
                    "contentUrl": video.contentUrl,
                }));
                setVideoSchema(schemaVideos);
            })
            .catch((err) => {
                console.error("Error loading video schema data:", err);
            });
    }, []);

    useEffect(() => {
        if (videoSchema.length === 0) return;

        // Create JSON-LD script tag with all videos as an array
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.textContent = JSON.stringify(videoSchema, null, 2);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, [videoSchema]);

    return null;
};

export default VideoSchema;
